import React, { useContext } from 'react'
import { AuthContext } from '../../../Api/firebase'
import { NameCon } from './styles'

export const ProfileName: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { firstName, lastName } = useContext(AuthContext)!

  return (
    <>
    { firstName && lastName && <NameCon><p className='name'>{firstName} {lastName}</p></NameCon>}
    </>
  )
}